import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';

interface SelectAllCheckboxSignature {
  Args: {
    selectedItemCount: number;
    totalItemCount: number;
  };
  Element: HTMLInputElement;
}

export default class SelectAllCheckbox extends Component<SelectAllCheckboxSignature> {
  checkboxId = `select-all-checkbox-${guidFor(this)}`;

  get allItemsSelected(): boolean {
    return this.args.totalItemCount > 0 && this.args.selectedItemCount === this.args.totalItemCount;
  }

  get someItemsSelected(): boolean {
    return this.args.selectedItemCount > 0;
  }

  get checkbox(): HTMLInputElement | null {
    return <HTMLInputElement>document.getElementById(this.checkboxId);
  }

  @action
  updateState(): void {
    if (this.checkbox) {
      this.checkbox.indeterminate = this.someItemsSelected && !this.allItemsSelected;
    }
  }

  <template>
    <input
      type="checkbox"
      checked={{this.allItemsSelected}}
      disabled={{eq @totalItemCount 0}}
      id={{this.checkboxId}}
      {{didInsert this.updateState}}
      {{didUpdate this.updateState @selectedItemCount @totalItemCount}}
      ...attributes
    />
  </template>
}
